import React from 'react';
import { Title, Button, Text } from 'ui';
import logo from '../assets/logo.png'

export default function PasswordReset(props) {


  return (
    <div className="auth auth-login">
      <div className="auth-sidebar">
        <img src={logo} alt="Taptivate" className="auth-logo"/>
        <Title white className="auth-title">Check your email</Title>
        <div style={{paddingBottom:16}}>
          <Text white>We’ve sent you and email with a link to reset your password.</Text>
        </div>
        <div style={{paddingBottom:16}}>
          <Text white>
            If you don’t see an email from us within a few minutes, <Button orange tertiary to="reset-password-send">try again here.</Button>
          </Text>
        </div>
        <div style={{paddingBottom:16}}>
          <Text white>
            Once you're done, <Button orange tertiary to="login">login here.</Button>
          </Text>
        </div>
      </div>
    </div>
  );
}